import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    // Core tagline
    "hero.tagline": "Besoin d'aide ? On est là.",
    "hero.core_message": "Besoin d'aide ? Propose ton prix. Un helper près de toi peut répondre.",
    "hero.title_1": "Propose ton prix.",
    "hero.title_helper": "Un helper",
    "hero.title_near": "près de chez toi.",
    "hero.subtitle": "Go Helper est un réseau local où des personnes près de chez toi peuvent t'aider — rapidement, simplement, et en toute sécurité.",
    "hero.cta_publish": "Publier une tâche",
    "hero.cta_helper": "Je veux aider",
    "hero.trust_payment": "Paiement sécurisé",
    "hero.trust_local": "100% local",
    "hero.trust_fast": "Très rapide",

    // Stats
    "stats.tasks_done": "tâches complétées",
    "stats.active_helpers": "helpers actifs",
    "stats.reviews": "avis",
    "stats.rating": "note moyenne",

    // Gallery
    "gallery.kicker": "Nos helpers",
    "gallery.title_1": "En casquette et uniforme",
    "gallery.title_2": "officiel",
    "gallery.subtitle": "Reconnaissables dès le premier coup d'œil. Un t-shirt navy, une casquette GH, et une volonté d'aider.",
    "gallery.available": "Helper disponible",

    // Not a job
    "notjob.kicker": "À retenir",
    "notjob.title_brand": "Go Helper",
    "notjob.title_rest": "n'est pas un emploi.",
    "notjob.body_1": "C'est un réseau local où tu peux",
    "notjob.body_accent": "faire de l'argent en aidant des gens",
    "notjob.body_2": "près de chez toi — quand tu veux, à ton rythme.",

    // Categories
    "cat.kicker": "Catégories",
    "cat.title": "Ce qu'on peut faire pour toi",
    "cat.publish": "Publier",

    // How it works
    "how.kicker": "Comment ça marche",
    "how.title": "3 étapes. C'est tout.",
    "how.step_1_title": "Publie ta tâche",
    "how.step_1_body": "Décris ce dont tu as besoin, ajoute des photos et propose ton prix.",
    "how.step_2_title": "Un helper accepte",
    "how.step_2_body": "Quelqu'un près de chez toi accepte. Tu paies via Go Helper en toute sécurité.",
    "how.step_3_title": "Confirme et évalue",
    "how.step_3_body": "Une fois la tâche faite, confirme. Le helper reçoit son paiement.",

    // Earnings
    "earn.kicker": "Pour les helpers",
    "earn.title_1": "Combien tu",
    "earn.title_accent": "gagnes",
    "earn.subtitle": "Le montant proposé par le client, c'est ce que tu reçois. Simple, clair, sans surprise.",
    "earn.cta": "Devenir helper",
    "earn.disclaimer": "Exemples. Le prix final est toujours fixé par le client.",

    // Pricing
    "pricing.kicker": "Tarification transparente",
    "pricing.title": "Tu vois tout avant de payer.",
    "pricing.bullet_1": "Frais fixe 3 $ + commission 15 %",
    "pricing.bullet_2": "Option urgence +30 % (si besoin rapide)",
    "pricing.bullet_3": "Paiement gardé en fiducie, libéré après confirmation",

    // Common
    "nav.login": "Connexion",
    "nav.signup": "Commencer",
    "nav.my_dashboard": "Mon tableau",
    "nav.follow_us": "Suis-nous :",
    "footer.tagline": "© 2026 Go Helper · Besoin d'aide ? On est là.",
    "lang.label": "Langue",
  },
  en: {
    "hero.tagline": "Need help? We're here.",
    "hero.core_message": "Need help? Set your price. A helper near you can respond.",
    "hero.title_1": "Set your price.",
    "hero.title_helper": "A helper",
    "hero.title_near": "near you.",
    "hero.subtitle": "Go Helper is a local network where people near you can help — quickly, simply, and safely.",
    "hero.cta_publish": "Post a task",
    "hero.cta_helper": "I want to help",
    "hero.trust_payment": "Secure payment",
    "hero.trust_local": "100% local",
    "hero.trust_fast": "Very fast",

    "stats.tasks_done": "tasks completed",
    "stats.active_helpers": "active helpers",
    "stats.reviews": "reviews",
    "stats.rating": "average rating",

    "gallery.kicker": "Our helpers",
    "gallery.title_1": "Wearing the official",
    "gallery.title_2": "uniform",
    "gallery.subtitle": "Instantly recognizable. A navy t-shirt, a GH cap, and a willingness to help.",
    "gallery.available": "Helper available",

    "notjob.kicker": "Important",
    "notjob.title_brand": "Go Helper",
    "notjob.title_rest": "is not a job.",
    "notjob.body_1": "It's a local network where you can",
    "notjob.body_accent": "make money helping people",
    "notjob.body_2": "near you — whenever you want, at your own pace.",

    "cat.kicker": "Categories",
    "cat.title": "What we can do for you",
    "cat.publish": "Post",

    "how.kicker": "How it works",
    "how.title": "3 steps. That's it.",
    "how.step_1_title": "Post your task",
    "how.step_1_body": "Describe what you need, add photos, and set your price.",
    "how.step_2_title": "A helper accepts",
    "how.step_2_body": "Someone nearby accepts. You pay through Go Helper, fully secured.",
    "how.step_3_title": "Confirm and rate",
    "how.step_3_body": "Once it's done, confirm. The helper gets paid.",

    "earn.kicker": "For helpers",
    "earn.title_1": "How much do you",
    "earn.title_accent": "earn",
    "earn.subtitle": "The amount the client sets is what you receive. Simple, clear, no surprises.",
    "earn.cta": "Become a helper",
    "earn.disclaimer": "Examples. The final price is always set by the client.",

    "pricing.kicker": "Transparent pricing",
    "pricing.title": "See everything before you pay.",
    "pricing.bullet_1": "$3 fixed fee + 15% commission",
    "pricing.bullet_2": "Urgent option +30% (if you need it fast)",
    "pricing.bullet_3": "Payment held in escrow, released after confirmation",

    "nav.login": "Log in",
    "nav.signup": "Get started",
    "nav.my_dashboard": "My dashboard",
    "nav.follow_us": "Follow us:",
    "footer.tagline": "© 2026 Go Helper · Need help? We're here.",
    "lang.label": "Language",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("gh_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("gh_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => (dict[lang] && dict[lang][key]) || dict.fr[key] || key;
  const setLang = (l) => setLangState(l);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
